/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import isNil from 'lodash/isNil';

import ScheduleLayout from './schedule-layout';
import ScheduleMedium from './schedule-medium';
import ScheduleOrphan from './schedule-orphan';
import SchedulePlaylist from './schedule-playlist';

// TODO #458 Schedule vrstvy nyní:
// 1. Vrstva úloh (ScheduleManager)
//   - Je třeba vybrat úlohu, která se má zobrazovat v nějakém okamžiku (teď).
//   - Nyní se vybere vždy jedna úloha. Následně bude propracováno při plánování dle kalendáře.
// 2. Vrstva slotů (ScheduleLayout)
//   - Rozdělení plochy na paralelní přehrávače médií.
//   - Dovolit zanořování, nebo řešit v ploché struktuře?
// 3. Vrstva strategií (ScheduleStrategy)
//   - Sériové přehrávání médií.
// TODO #458 Schedule vrstvy při zanoření šablony:
// - Nahoře zůstává vrstva úloh.
// - Vrstva strategií může obsahovat další vrstvu slotů.
// - Možná by bylo vhodné sloučit logiku pro rozvětvení obsahu:
//   ScheduleManager, ScheduleLayer, ScheduleTrack
//   ({layout, medium, playlist}) => ScheduleStrategy
// TODO #458 Přepracovat na ScheduleContentTask / ContentTaskScheduleStrategy / ContentTaskScheduler
// - Každopádně vracet jen jednu ScheduleStrategy.
/**
 * Správce plánování obsahu.
 * ![Diagram tříd](./core/schedule/schedule.doc.png)
 */
class ScheduleManager {
  /**
   * Vytvoří instanci.
   * @param {ViewerRegistry} viewerRegistry Registr informací o typech médií.
   */
  constructor(viewerRegistry) {
    this.viewerRegistry = viewerRegistry;
  }

  /**
   * Detekuje a vytvoří strategie pro plánování přehrávání obsahu.
   * @param {ContentTask|null} contentTask Obsahová úloha, pro kterou se mají strategie vytvořit.
   * @param {Array.<Layer>} layerArray Seznam vrstev.
   * @param {Session} session Sezení s nastavením zařízení.
   * @param {DS} store Datový sklad.
   * @returns {Array.<ScheduleStrategy>} Seznam detekovaných strategií.
   */
  createStrategies(contentTask, layerArray, session, store) {
    // TODO #138 Zavést registry pro detekce strategií?
    if (isNil(contentTask)) {
      return [];
    }
    // TODO #138 Zavést registry pro detekce strategií?
    const { viewerRegistry } = this;
    const { layout, medium, playlist } = contentTask;
    const hasLayout = !isNil(layout);
    const hasMedium = !isNil(medium);
    const hasPlaylist = !isNil(playlist);
    if (hasLayout && !hasMedium && !hasPlaylist) {
      return ScheduleLayout.createStrategies(
        store,
        session,
        layerArray,
        layout,
        viewerRegistry
      );
      // TODO #458 Prototyp zpracování layout.playDuration
      // - Obalení do ScheduleOrphan řešit pravděpodobně pouze zde a ve v playlistech.
      // const scheduleLayout = new ScheduleLayout(store, session, layerArray, layout, this.viewerRegistry);
      // return [new ScheduleOrphan(layout.playDuration, scheduleLayout)];
    }
    if (hasMedium && !hasLayout && !hasPlaylist) {
      const scheduleMedium = new ScheduleMedium(
        session,
        medium,
        viewerRegistry
      );
      return [new ScheduleOrphan(medium.playDuration, scheduleMedium)];
    }
    if (hasPlaylist && !hasLayout && !hasMedium) {
      return [new SchedulePlaylist(store, session, playlist, viewerRegistry)];
    }
    throw new Error(
      `Unable to detect strategy for content task ${contentTask}.`
    );
  }
}

export default ScheduleManager;
